import * as Sentry from '@sentry/react';
import { SENTRY_DSN } from 'src/config-global';

const ENABLE_SENTRY = process.env.REACT_APP_ENABLE_SENTRY === 'true';

export const initSentry = () => {
  if(ENABLE_SENTRY) {
    Sentry.init({
      dsn: SENTRY_DSN,
      integrations: [
        Sentry.replayIntegration(),
        Sentry.browserTracingIntegration(),
        Sentry.browserProfilingIntegration(),
      ],
      tracesSampleRate: 0.3,
      replaysSessionSampleRate: 1.0,
      replaysOnErrorSampleRate: 1.0,
      dataCollection: {
        userInfo: false,
        cookies: false,
        httpHeaders: {
          request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
          response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
        },
        httpBodies: [],
        urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
        genAI: { inputs: false, outputs: false },
        databaseQueryData: false,
        queues: false,
        graphQL: { document: false, variables: false },
      },
    });
  }
};
